/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesUserSchema } from "./userSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesUserNotificationSettingsSchema = z.object({
  userId: z.string().nullish(),
  get user() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  email: z.optional(z.boolean()),
  tournamentStart: z.optional(z.boolean()),
  newsAndRecommendations: z.optional(z.boolean()),
  onboardingEmail1SentAtUtc: z.iso.datetime().nullish(),
  onboardingEmail2SentAtUtc: z.iso.datetime().nullish(),
  onboardingEmail3SentAtUtc: z.iso.datetime().nullish(),
  emailTeams: z.optional(z.boolean()),
  discordEnabled: z.optional(z.boolean()),
  discordSendAll: z.optional(z.boolean()),
  discordTypes: z.string().nullish(),
  discordTournaments: z.optional(z.boolean()),
  discordMatches: z.optional(z.boolean()),
  discordTeam: z.optional(z.boolean()),
  preset: z.string().max(50).nullish(),
  channelOverridesJson: z.string().nullish(),
  updatedAt: z.iso.datetime().nullish(),
});
